// extracted by mini-css-extract-plugin
export default {"conteudo":"Layout_conteudo__SfuyG","menuLimpo":"Layout_menuLimpo__yxWpT"};